/**
 * DOM の準備完了を待ってから関数を実行するヘルパー
 *
 * 目的:
 * - DOMContentLoaded より前に呼ばれた場合は、イベント発火後に実行する
 * - すでに DOMContentLoaded 済みの場合は、その場で即実行する
 *
 * なぜ必要？
 * - 動的 import でページJSを「後から読み込む」構成だと、
 *   import 完了時点では DOMContentLoaded がすでに発火済みなことがある。
 * - その場合に DOMContentLoaded へ listener を追加しても実行されず、初期化が漏れる事故が起きる。
 * - readyState を見て「待つ or 即実行」を切り替えることで事故を防ぐ。
 *
 * @param {Function} fn DOM が使える状態になったら実行したい関数
 */
export function onReady(fn) {
	// まだ DOM を構築中（DOMContentLoaded 前）なら、発火を待つ
	if (document.readyState === "loading") {
		// once: true で 1回だけ実行して自動でリスナー解除（多重実行防止）
		document.addEventListener("DOMContentLoaded", fn, { once: true });
	} else {
		// すでに DOMContentLoaded 済みなら、その場で即実行
		fn();
	}
}
